import React, { FC } from 'react';
import TrimLevelName from './trimLevelName/TrimLevelName';
import { ITrimSelectedLevel } from '../../../trimLevels/model/ITrimSelectedLevel';
import { useTheme } from '@material-ui/core';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';

export interface ISelectedTrimLevelNameProps {
  trimName: string;
  selectedTrimLevels: ITrimSelectedLevel[];
  section?: string;
}

const SelectedTrimLevelName: FC<ISelectedTrimLevelNameProps> = ({ trimName, selectedTrimLevels, section }) => {
  const {
    spc: {
      trimLevels: { hideVariantsTrimLevelSecondaryName },
    },
  } = useTheme<ISpcTheme>();

  return (
    <>
      {!hideVariantsTrimLevelSecondaryName && (
        <TrimLevelName name={trimName} type="span" section={section} dataTest="trim_level_name:trim" />
      )}
      {selectedTrimLevels.map(selectedTrimLevel => (
        <TrimLevelName
          key={selectedTrimLevel.key}
          name={` ${selectedTrimLevel.value}`}
          type="span"
          section={section}
          dataTest={`trim_level_name:${selectedTrimLevel.key}`}
        />
      ))}
    </>
  );
};

export default SelectedTrimLevelName;
